module.exports = __webpack_public_path__ + "static/media/elvan-01.8297d7d3.jpg";